<template>
  <div class="support container">
    <div class="support__header">
      <h3 class="support__title">Back this project</h3>
      <a href="#0" class="close" @click="handleBacktoggle()">
        <img src="../../assets/crowdfunding/icon-close-modal.svg" alt="close - menu">
      </a>
      <p class="support__text">
        Want to support us in bringing Mastercraft Bamboo Monitor Riser out in the world?
      </p>
    </div>
    <div class="pledge no-reward" :class="classes(1000, 0)">
      <div class="pledge__select">
        <input type="radio" name="select" id="pledge" v-model="pledge" value="0">
        <label for="pledge">
          <h3 class="pledge__name">Pledge with no reward</h3>
        </label>
      </div>
      <div class="pledge__description">
        Choose to support us without a reward if you simply believe in our project. As a backer,
        you will be signed up to receive product updates via email.
      </div>
        <div class="pledge__form" v-if="pledge == 0">
          form
        </div>
    </div>

      <div
          class="pledge"
          :class="classes(reward.left, reward.id)"
          v-for="reward in data"
          :key="reward.id"
        >
        <div class="pledge__select">
          <input
            type="radio"
            name="select"
            :disabled="!reward.left"
            v-model="pledge"
            :id="reward.name"
            :value="reward.id">
          <label :for="reward.name">
            <h3 class="pledge__name">{{reward.name}}</h3>
            <h4 class="pledge__title">{{reward.title}}</h4>
          </label>
        </div>
        <p class="pledge__description">{{reward.text}}</p>
        <div class="pledge__left">
          <span class="number">{{reward.left}}</span> left
        </div>
        <form class="form" v-if="(reward.id === pledge) && reward.left">
          <h4 class="form__title">Enter Your pledge</h4>
          <input type="text" name="" id="" class="form__input" min="0">
          <!-- <span>josiah</span> -->
          <Button value="Continue" />
        </form>
      </div>
    </div>

</template>

<script>
import Button from './reusable/Button.vue';

export default {
  name: 'Rewards',
  components: {
    Button,
  },
  data() {
    return {
      pledge: Infinity,
      show: false,
    };
  },
  props: {
    data: Array,
  },
  methods: {
    handleSubmit() {
      this.$emit('successtoggle');
    },
    toogle() {
      this.$emit('toggleBackproject');
    },
    classes(left, rewardId) {
      let res = '';
      res += left ? 'active ' : 'inactive ';
      res += (Number(this.pledge) === rewardId) && left ? 'selected' : '';
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>

.selected {
  border: 2px dotted var(--moderate-cyan);
}

.form {
  display: grid;
  grid-template-areas: "a a" "b c";
  grid-template-rows: 0.5fr 1fr;
  grid-template-columns: 0.5fr 1fr;
  align-items: center;
  grid-row-gap: calc(var(--sm-spacer) / 2);
  max-width: var(--text-width);

  border-top: 1px solid var(--gray);
  margin-top: calc(var(--sm-spacer) / 1.5);
  padding-top: calc(var(--sm-spacer) / 1.5);

  &__input {
    grid-area: b;
    outline: initial;
    border: 1px solid;
    padding: 1em 1.5em;
  }

  &__title {
    grid-area: a;
    justify-self: center;
  }
}

.pledge {
  box-shadow: 0 0 2px 0 var(--dark-gray);
  border-radius: var(--border-radius);
  padding: calc(var(--sm-spacer) / 1);
  margin: 0 auto;

  + .pledge {
    margin-top: var(--sm-spacer);
  }

  &__select {
    display: flex;
    align-items: center;
    gap: calc(var(--sm-spacer) / 2);
    padding-left: 0; //??
    margin-bottom: calc(var(--sm-spacer) / 2);
    cursor: pointer;
  }

  &__title {
    color: var(--moderate-cyan);
    font-size: var(--fs-h5);
    font-weight: 500;
  }

  &__description {
    margin-bottom: calc(var(--sm-spacer) / 2);
  }

  &__left {
    display: flex;
    align-items: center;
    gap: calc(var(--sm-spacer) / 5);
    .number {
      font-size: var(--fs-h3);
      font-weight: 700;
    }
  }
}

.support {
  position: absolute;
  top: 10rem;
  left:0;
  right: 0;

  background-color: var(--white);
  padding: calc(var(--sm-spacer) * 1.5);
  box-shadow: 0 0 10px 5px var(--dark-gray);
  border-radius: var(--border-radius);
  max-width: calc(var(--text-width));

  &__header {
    display: grid;
    grid-template-areas: "a b" "c c";
    grid-row-gap: var(--sm-spacer);
    align-items: center;

    .close {
      cursor: pointer;
    }
  }

  &__title {
    font-size: var(--fs-h4);
  }

  &__header, &__description, &__cta, &__left {
    margin-bottom: calc(var(--sm-spacer) / 2);
  }
  .inactive {
    opacity: 0.5;
  }
}

</style>
